"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetWhitelabelDomain = void 0;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _useConstructorContextState = require("./useConstructorContextState");

var _constants = require("../../../pages/constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useGetWhitelabelDomain = function useGetWhitelabelDomain() {
  var state = (0, _useConstructorContextState.useConstructorContextState)();
  return (0, _get2["default"])(state, ['whitelabelDomain'], _constants.LT_DOMAIN);
};

exports.useGetWhitelabelDomain = useGetWhitelabelDomain;